<template>
    <div>
        <Head title="FAQ" />
        <!-- Start Hero -->
        <section class="relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">Frequently Asked Questions</h3>
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <!-- Start Section-->
        <section class="relative py-16">
            <div class="container">
                <div class="flex items-center justify-center mb-8"><search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input></div>
                <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                    <div class="lg:col-span-12 md:col-span-12">
                        <div id="tech">
                            <div id="accordion-collapseone" data-accordion="collapse" class="mt-6">
                                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden mt-4" v-for="(faq, fi) in faqs.data" :key="faq.id">
                                    <h2 class="text-base font-semibold" :id="'accordion-collapse-heading-'+fi">
                                        <button type="button" class="flex justify-between items-center p-5 w-full font-medium text-left"
                                                :class="{'bg-gray-50 dark:bg-slate-800 text-indigo-600':faq.active}"
                                                :data-accordion-target="'#accordion-collapse-body-'+fi"
                                                aria-expanded="true" :aria-controls="'accordion-collapse-body-'+fi" @click="toggleActive(fi)">
                                            <span>{{ faq.name }}</span>
                                            <svg data-accordion-icon class="w-4 h-4 shrink-0" :class="{'rotate-180' : faq.active}" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                                            </svg>
                                        </button>
                                    </h2>
                                    <div :id="'accordion-collapse-body-'+fi" :class="{'hidden':!faq.active}" :aria-labelledby="'accordion-collapse-heading-'+fi">
                                        <div class="p-5">
                                            <p class="text-slate-400 dark:text-gray-400" v-html="sanitizeHtml(faq.details)"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div><!--end grid-->
            </div><!--end container-->

            <div class="container md:mt-24 mt-16">
                <div class="grid grid-cols-1 text-center">
                    <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Have Question ? Get in touch!</h3>

                    <p class="text-slate-400 max-w-xl mx-auto">Start working with HelpDesk that can provide everything you need to generate awareness, drive traffic, connect.</p>

                    <div class="mt-6">
                        <a href="" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2"><i class="uil uil-phone"></i> Contact us</a>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End Section-->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import { Head } from '@inertiajs/inertia-vue3'
import sanitizeHtml from 'sanitize-html';
import SearchInput from '@/Shared/SearchInput'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import mapValues from "lodash/mapValues";
export default {
    layout: Layout,
    components: {
        Icon,
        Head,
        SearchInput
    },
    props: {
        faqs: Object,
        title: String,
        filters: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('faq'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods:{
        toggleActive(index){
            this.faqs.data[index].active = !this.faqs.data[index].active;
        },
        sanitizeHtml : sanitizeHtml,
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },

    created() {
        if(this.faqs.data.length){
            this.faqs.data[0].active = true;
        }
    }
}
</script>
